import attListThumbnailsView from './attListThumbnailsComponent.html';
import './attListThumbnailsComponent.css';

export function attListThumbnailsComponent() {
	return {
		restrict: 'E',
		scope: {},
		bindings: {
			attachments: '<',
		},
		controllerAs: 'vm',
		controller: attListThumbnailsComponentCtrl,
		template: attListThumbnailsView,
	};
}

class attListThumbnailsComponentCtrl {
	constructor(Att) {
		'ngInject';
		this.Att = Att;
	}

	/*
	 * Opens the attachment preview overlay
	 *
	 * @param {attachment} att  The attachment to be displayed
	 * @param {Int} selectedAttachmentIdx  The index of the attachment that should show
	 * @returns {undefined}
	 */
	previewAttachments(att, selectedAttIdx = 0) {
		if (this.viewAtt) {
			this.viewAtt(att, selectedAttIdx);
		} else {
			// default shows blue overlay preview page
			this.Att.openPost(this.post, selectedAttIdx);
		}
	}
}
